import React from 'react'
import "./award.css";
import { Awards } from '../data/Data';
function award() {
    return (
        <section className='paddings flexDisplay awardContainer'>
            <span>Our Awards</span>
            <p className='secondaryText'>Over 1,24,000+ Happy User Bieng With Us <br /> Still They Love Our Services</p>

            <div className="categorise">
                {Awards.map((item,index)=>(
                       <div className='onlyAward' key={index}>
                     <div className="icon">{item.icon}</div>
                     <h1>{item.num}</h1>
                     <p className='secondaryText'>{item.name}</p>
                    </div>
                ))}
               </div>
        </section>
    )
}

export default award
